import {ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppCommonModule} from '@app/components/app.common.module';
import {BaseComponent} from '@app/components/base/base.component';
import {
  GeneralInformationFormComponent
} from './components/general-information/general-information-form/general-information-form.component';
import {
  GeneralInformationReadonlyComponent
} from './components/general-information/general-information-readonly/general-information-readonly.component';
import {FiltersReadonlyComponent} from './components/filters/filters-readonly/filters-readonly.component';
import {InsuranceFormComponent} from './components/insurance-parametrics/insurance-form/insurance-form.component';
import {
  InsuranceReadonlyComponent
} from './components/insurance-parametrics/insurance-readonly/insurance-readonly.component';
import {ConditionReadonlyComponent} from './components/condition/condition-readonly/condition-readonly.component';
import {ConditionsComponent} from './components/condition/conditions/conditions.component';
import {FiltersFormComponent} from './components/filters/filters-form/filters-form.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  FinancialCondition,
  FinancialSetupCreationDto,
  FinancialSetupVersion,
  StandardFinancialSetupAttribute
} from "@app/pages/quote/standard-quote/model/financial-setup.model";
import {
  FinancialSetupService
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/financial-setup.service";
import {ActivatedRoute, Router} from "@angular/router";
import { TippyDirective } from '@ngneat/helipopper';
import {
  FinancialSetupModel
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/model-template/financial-setup.model";
import {Constants} from "@app/constants/Constants";
import {ImgReadonlyHeaderComponent} from "@components/img-readonly-header/img-readonly-header.component";
import { NotificationService } from '@app/services/notifications.service';
import { MenusServices } from '@app/services/menus.service';
import { environment } from '@env/environment.local';

@Component({
  selector: 'app-new-financial-setup',
  standalone: true,
  templateUrl: './new-financial-setup.component.html',
  styleUrl: './new-financial-setup.component.css',
  imports: [AppCommonModule, GeneralInformationFormComponent, GeneralInformationReadonlyComponent, FiltersFormComponent, FiltersReadonlyComponent, InsuranceFormComponent, InsuranceReadonlyComponent, ConditionReadonlyComponent, ConditionsComponent, TippyDirective, ImgReadonlyHeaderComponent]
})
export class NewFinancialSetupComponent
  extends BaseComponent
  implements OnInit, OnDestroy {

  private generalInformationSubscription: Subscription | null = null;

  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  financialSetupModels: FinancialSetupModel[] = [];
  dealerIds: number[] = [];
  isLoading: boolean = false;
  hasData: boolean = false;
  isMobile: boolean = false;
  standardFinancialSetupAttributes: StandardFinancialSetupAttribute[] = [];
  financialConditions: FinancialCondition[] = [];
  insuranceType: string = '';
  financialSetupCreationDto: FinancialSetupCreationDto = new FinancialSetupCreationDto();
  form: FormGroup;
  isReadyToEdit: boolean = false;
  id: string | null = null;
  versions: FinancialSetupVersion[] = [];
  version: any = '';
  status: any = '';
  classification: boolean;
  allowCapitalGrace: boolean = false;
  allowInterestGrace: boolean = false;

  // Estado temporal para manejar cambios antes de guardar
  private originalFinancialSetupCreationDto: FinancialSetupCreationDto = new FinancialSetupCreationDto();
  private originalStandardFinancialSetupAttributes: StandardFinancialSetupAttribute[] = [];
  private originalFinancialConditions: FinancialCondition[] = [];
  private originalInsuranceType: string = '';
  private originalFinancialSetupModels: FinancialSetupModel[] = [];
  private originalDealerIds: number[] = [];
  private originalClassification: boolean;



  data: any[] = [];

  constructor(private fb: FormBuilder,
              private router: Router,
              public activatedRoute: ActivatedRoute,
              private financialSetupService: FinancialSetupService,
              notification: NotificationService,
              menu: MenusServices,

            ) {
    super(activatedRoute, menu, notification);
    this.createForm()
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      if (this.id) {
        this.isLoading = true;
        this.financialSetupService.getFinancialSetupById(this.id).subscribe({
          next: (response) => {
            this.financialSetupCreationDto = response.data;
            this.standardFinancialSetupAttributes = this.financialSetupCreationDto.standardFinancialSetupAttributes
            this.financialConditions = this.financialSetupCreationDto.financialConditions;
            this.insuranceType = this.financialSetupCreationDto.insurancesType;
            this.financialSetupModels = this.financialSetupCreationDto.financialSetupModels;
            this.dealerIds = this.financialSetupCreationDto.dealerIds;
            this.version = this.financialSetupCreationDto.version ?? 'Versión no disponible';
            this.status = this.financialSetupCreationDto.status
            this.isReadyToEdit = true;

            // Initialize preferences from DTO
            this.allowCapitalGrace = this.financialSetupCreationDto.allowCapitalGrace || false;
            this.allowInterestGrace = this.financialSetupCreationDto.allowInterestGrace || false;

            // Guardar estado original para poder restaurar en caso de cancelar
            this.saveOriginalState();

            if (this.form) {
              this.createFormToUpdate();
            }
            this.isLoading = false;

          },
          error: (error) => {
            console.error(error);
            this.isLoading = false;
          }
        });
      } else {
        this.isLoading = false;
        this.createForm();
      }
    });

    this.mapToFinancialSetup();
  }

  ngOnDestroy() {
    if (this.generalInformationSubscription) {
      this.generalInformationSubscription.unsubscribe();
    }
  }

  createForm() {
    if (!this.fb) return;
    this.form = this.fb.group({
      condition: [null],
      standardFinancialSetupAttributes: [null],
      generalInformation: [null],
      insurance: [null],
    });

    // Inicializar preferencias con valores por defecto
    this.allowCapitalGrace = false;
    this.allowInterestGrace = false;

    // Subscribe to general information form changes to update preferences
    this.subscribeToGeneralInformation();
  };

  private subscribeToGeneralInformation() {
    // Unsubscribe from previous subscription if exists
    if (this.generalInformationSubscription) {
      this.generalInformationSubscription.unsubscribe();
    }

    const generalInformationControl = this.form.get('generalInformation');
    if (!generalInformationControl) return;

    // Subscribe to general information form changes to update preferences
    // Usar debounce para evitar actualizaciones muy frecuentes
    this.generalInformationSubscription = generalInformationControl.valueChanges.subscribe((value) => {
      // Solo actualizar si el valor es un objeto válido con las propiedades esperadas
      if (value && typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if ('allowCapitalGrace' in value) {
          this.allowCapitalGrace = value.allowCapitalGrace || false;
        }
        if ('allowInterestGrace' in value) {
          this.allowInterestGrace = value.allowInterestGrace || false;
        }
      }
    });
  }

  createFormToUpdate() {
    if (!this.fb) return;
    this.form = this.fb.group({
      condition: [this.financialConditions],
      standardFinancialSetupAttributes: [this.standardFinancialSetupAttributes],
      generalInformation: [this.financialSetupCreationDto],
      insurance: [this.financialSetupCreationDto.insurancesType],
    });

    // Initialize preferences from DTO
    this.allowCapitalGrace = this.financialSetupCreationDto.allowCapitalGrace || false;
    this.allowInterestGrace = this.financialSetupCreationDto.allowInterestGrace || false;

    // Subscribe to general information form changes to update preferences
    this.subscribeToGeneralInformation();
  };


  cancel() {
    // Restaurar el estado original antes de navegar
    this.restoreOriginalState();

    // Si estamos creando un nuevo paquete (sin ID), ir al listado
    // Si estamos editando un paquete existente (con ID), ir a la vista de solo lectura
    if (this.id) {
      this.router.navigate([`/financial-setup/read-only/${this.financialSetupCreationDto.id}`]);
    } else {
      this.router.navigate(['/financial-setup/list']);
    }
  }

  private saveOriginalState() {
    // Guardar una copia profunda del estado original
    this.originalFinancialSetupCreationDto = JSON.parse(JSON.stringify(this.financialSetupCreationDto));
    this.originalStandardFinancialSetupAttributes = JSON.parse(JSON.stringify(this.standardFinancialSetupAttributes));
    this.originalFinancialConditions = JSON.parse(JSON.stringify(this.financialConditions));
    this.originalInsuranceType = this.insuranceType;
    this.originalFinancialSetupModels = JSON.parse(JSON.stringify(this.financialSetupModels));
    this.originalDealerIds = [...this.dealerIds];
    this.originalClassification = this.classification;
  }

  private restoreOriginalState() {
    // Restaurar el estado original
    this.financialSetupCreationDto = JSON.parse(JSON.stringify(this.originalFinancialSetupCreationDto));
    this.standardFinancialSetupAttributes = JSON.parse(JSON.stringify(this.originalStandardFinancialSetupAttributes));
    this.financialConditions = JSON.parse(JSON.stringify(this.originalFinancialConditions));
    this.insuranceType = this.originalInsuranceType;
    this.financialSetupModels = JSON.parse(JSON.stringify(this.originalFinancialSetupModels));
    this.dealerIds = [...this.originalDealerIds];
    this.classification = this.originalClassification;

    if (this.form) {
      this.createFormToUpdate();
    }
  }

  save() {
    const hasGracePeriods = this.financialConditions.some(condition =>
      condition.gracePeriod && condition.gracePeriod > 0
    );

    if (hasGracePeriods && !this.allowCapitalGrace && !this.allowInterestGrace) {
      this.showNotificationError('Las preferencias no pueden estar vacías, ya que existen períodos de gracia ingresados.');
      return;
    }

    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control && control.invalid) {
          control.markAsTouched();
        }
      });
      this.showNotificationError('Por favor, complete todos los campos requeridos correctamente.');
      return;
    }

    if (this.isReadyToEdit) {
      this.updateFinancialSetup();
    } else {
      this.createFinancialSetup();
    }
  }

  updateFinancialSetup() {
    this.mapToFinancialSetup();
    this.isLoading = true;
    this.financialSetupService.updateFinancialSetup(this.financialSetupCreationDto.id, this.financialSetupCreationDto)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (!response.status) {
            if (response.errors && response.errors.length > 0
              && Constants.FINANCIAL_SETUP_NAME_ALREADY_EXISTS === response.errors[0]) {
              this.showNotificationError(`El paquete financiero no se pudo actualizar, ya existe un paquete financiero con el mismo nombre. ${this.financialSetupCreationDto.financialSetupName}`)
            }
          } else {
            // Solo actualizar el estado original cuando la operación sea exitosa
            this.saveOriginalState();
            this.showNotificationSuccess('El paquete financiero ha sido actualizado con éxito.')
            this.router.navigate([`/financial-setup/read-only/${this.financialSetupCreationDto.id}`]);
          }

        },
        error: (error) => {
          this.showNotificationError('Ha ocurrido un error, el paquete financiero no se pudo actualizar.')
          this.isLoading = false;
        }
      });
  }

  financialSetupCreationChanges(data: any) {
    /*  if(!data) return;
      let activeEndDate = new Date(data.activeEndDate);
      let activeStartDate = new Date(data.activeStartDate)
      this.financialSetupCreationDto = data;
      this.financialSetupCreationDto.activeStartDate = activeStartDate;
      this.financialSetupCreationDto.activeEndDate = activeEndDate*/
  }

  mapToFinancialSetup() {
    const formValue = this.form.getRawValue();
    const generalInformation = formValue?.generalInformation;

    // Validar que generalInformation existe y tiene propiedades antes de acceder a sus propiedades
    if (!generalInformation || typeof generalInformation !== 'object' || Object.keys(generalInformation).length === 0) {
      console.warn('No se puede mapear el formulario: generalInformation es null, undefined o está vacío');
      return;
    }

    // Validar que las fechas existan antes de crear objetos Date
    // if (!generalInformation.activeEndDate || !generalInformation.activeStartDate) {
    //   console.warn('No se puede mapear el formulario: fechas requeridas faltantes');
    //   return;
    // }

    // Convertir taxFree a boolean antes de hacer el JSON.parse/stringify
    if (generalInformation.taxFree !== undefined) {
      generalInformation.taxFree = generalInformation.taxFree === true || generalInformation.taxFree === "true" || generalInformation.taxFree === "TRUE";
    }

    let activeEndDate = new Date(generalInformation?.activeEndDate);
    let activeStartDate = new Date(generalInformation?.activeStartDate)

    const tempFinancialSetupCreationDto = JSON.parse(JSON.stringify(generalInformation));
    tempFinancialSetupCreationDto.activeStartDate = activeStartDate;
    tempFinancialSetupCreationDto.activeEndDate = activeEndDate;
    const productTypesWithAllUnits = new Set(
      this.standardFinancialSetupAttributes
        .filter((a) => a.type === 'PRODUCT_TYPE' && a.partial === false)
        .map((a) => a.value)
    );
    tempFinancialSetupCreationDto.financialSetupModels = this.financialSetupModels.filter(
      (m) => !productTypesWithAllUnits.has(m.modelType)
    );
    tempFinancialSetupCreationDto.dealerIds = this.dealerIds;
    tempFinancialSetupCreationDto.classification = this.classification;
    // Asegurar que taxFree se incluya explícitamente como boolean (por si acaso)
    if (tempFinancialSetupCreationDto.taxFree !== undefined) {
      tempFinancialSetupCreationDto.taxFree = tempFinancialSetupCreationDto.taxFree === true || tempFinancialSetupCreationDto.taxFree === "true" || tempFinancialSetupCreationDto.taxFree === "TRUE";
    } else {
      tempFinancialSetupCreationDto.taxFree = false;
    }

    if (this.id) {
      tempFinancialSetupCreationDto.id = parseInt(this.id);
    }

    tempFinancialSetupCreationDto.financialConditions = [];
    tempFinancialSetupCreationDto.financialConditions = this.financialConditions.map((condition) => {
      return {
        id: condition.id,
        allowPaymentDay: condition.allowPaymentDay,
        minDownPaymentPercentage: condition.minDownPaymentPercentage,
        maxDownPaymentPercentage: condition.maxDownPaymentPercentage,
        nominalRate: condition.nominalRate,
        insuranceNominalRate: condition.insuranceNominalRate,
        openingFeePercentage: condition.openingFeePercentage,
        purchasePercentage: condition.purchasePercentage,
        paymentIncentive: condition.paymentIncentive,
        warrantyDepositPercentage: condition.warrantyDepositPercentage ?? 0,
        gracePeriod: condition.gracePeriod,
        gracePeriodInterest: condition.gracePeriodInterest,
        term: condition.term,
        active: condition.active
      }
    });

    tempFinancialSetupCreationDto.standardFinancialSetupAttributes = [];

    tempFinancialSetupCreationDto.standardFinancialSetupAttributes = this.standardFinancialSetupAttributes.map((attribute) => ({
        id: attribute.id,
        type: attribute.type,
        value: attribute.value,
        partial: attribute.partial
      }));

    tempFinancialSetupCreationDto.insurancesType = this.insuranceType;

    // Si subsidio es "No aplica", no persistir valor previo
    if (tempFinancialSetupCreationDto.subsidyType === 'NOT_TAXED') {
      tempFinancialSetupCreationDto.subsidyValue = null;
    }

    if (!environment.showFinancialSetupQuoteValidityDays) {
      delete tempFinancialSetupCreationDto.quoteValidityDays;
    }

    if (environment.featureLoyaltyFeriaQuotation) {
      const v = tempFinancialSetupCreationDto.loyaltyFinancialPackage;
      tempFinancialSetupCreationDto.loyaltyFinancialPackage =
        v === true || v === 'true' || v === 'TRUE';
      delete tempFinancialSetupCreationDto.feriaFinancialPackage;
    } else {
      delete tempFinancialSetupCreationDto.loyaltyFinancialPackage;
      delete tempFinancialSetupCreationDto.feriaFinancialPackage;
    }

    this.financialSetupCreationDto = tempFinancialSetupCreationDto;
  }

  createFinancialSetup() {
    this.mapToFinancialSetup();
    this.isLoading = true;
    this.financialSetupService.createFinancialSetup(this.financialSetupCreationDto)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (!response.status) {
            if (response.errors && response.errors.length > 0
              && Constants.FINANCIAL_SETUP_NAME_ALREADY_EXISTS === response.errors[0]) {
              const message = `El paquete financiero no se pudo crear, ya existe un paquete financiero con el mismo nombre. ${this.financialSetupCreationDto.financialSetupName}`
              this.showNotificationError(message);
            }
          } else {
            this.saveOriginalState();
            this.showNotificationSuccess('El paquete financiero ha sido creado con éxito.')
            this.router.navigate([`/financial-setup/read-only//${response?.data?.id}`]);
          }

        },
        error: (error) => {
          this.isLoading = false;
          this.showNotificationError('Ha ocurrido un error, el paquete financiero no se pudo crear.')
        }
      });
  }

  changeCondition(financialConditions: FinancialCondition[]) {
    if (!this.areConditionsEqual(this.financialConditions, financialConditions)) {
      this.financialConditions = [...(financialConditions || [])];
    }
  }

  private areConditionsEqual(a: FinancialCondition[], b: FinancialCondition[]): boolean {
    if (!a && !b) return true;
    if (!a || !b) return false;
    if (a.length !== b.length) return false;

    const sortFn = (x: FinancialCondition, y: FinancialCondition) => x.term - y.term;
    const sortedA = [...a].sort(sortFn);
    const sortedB = [...b].sort(sortFn);

    const getValues = (c: FinancialCondition) => [
      c.id,
      c.minDownPaymentPercentage,
      c.maxDownPaymentPercentage,
      c.nominalRate,
      c.insuranceNominalRate,
      c.openingFeePercentage,
      c.purchasePercentage,
      c.paymentIncentive,
      c.warrantyDepositPercentage,
      c.gracePeriod,
      c.term
    ];

    return JSON.stringify(sortedA.map(getValues)) === JSON.stringify(sortedB.map(getValues));
  }

  getInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  standardFinancialSetupAttributesChange(attributes: StandardFinancialSetupAttribute[]) {
    if (!attributes) return;
    this.standardFinancialSetupAttributes = attributes;
  }

  insuranceTypeChange(value: string) {
    if (!value) return;
    this.insuranceType = value;
  }

  financialConditionsChange(conditions: FinancialCondition[]) {
    const sortedConditions = [...(conditions || [])].sort((a, b) => a.term - b.term);

    if (!this.areConditionsEqual(this.financialConditions, sortedConditions)) {
      this.financialConditions = sortedConditions;
    }
  }

  modelSelected(models: FinancialSetupModel[]) {
    this.financialSetupModels = models;
  }

  dealerSelected(dealerIds: number[]) {
    this.dealerIds = dealerIds;
  }

  onClassificationChange(newValue: boolean): void {
    this.classification = newValue;
  }

}
